import React, { useEffect } from 'react';

import CVRailDocument from '../rail-document.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/testing.en';

// Instructions for TestFlight testers. This page is unlisted: nothing on the
// site links to it, and it asks search engines not to index it. The link is
// sent to testers by email. The page itself is written out once per language
// in locales/, with the invite links from the config.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/testing.${code}`));

// keep the page out of search results for as long as it is on screen
const useNoIndex = () => {
    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.appendChild(meta);

        return () => meta.remove()
    }, [])
}

const CaptiVisionTesting = () => {
    useNoIndex()

    const [page, lang] = useLocalizedPage(PAGES);

    return (
        <CVRailDocument
            lang={lang}
            pageTitle={page?.title}
            className="cv-testing"
            contents={page?.contents}
            railLabel={page?.railLabel}
            head={page?.head}>
            {page?.body}
        </CVRailDocument>
    )
}

export default CaptiVisionTesting;
